import {createApp} from 'vue';
import * as components from './vue/components/index';
import '../styles/main.css';

import './modules/lab_branding';
import './modules/modal';
import './modules/header';
import {addToCart} from './modules/cart';
import {
  publishEngagementTime,
  publishScrollDepth,
  publishCtaClick,
  publishMenuClick,
  publishKlaviyoForm,
  publishAccountClicked,
  publishSignupClick,
} from './modules/customer-events';

theme.cart = theme.cart || {};
theme.customerEvents = theme.customerEvents || {};

theme.cart.addToCart = addToCart;
theme.customerEvents.publishCtaClick = publishCtaClick;
theme.customerEvents.publishMenuClick = publishMenuClick;
theme.customerEvents.publishKlaviyoForm = publishKlaviyoForm;
theme.customerEvents.publishScrollDepth = publishScrollDepth;
theme.customerEvents.publishEngagementTime = publishEngagementTime;
theme.customerEvents.publishAccountClicked = publishAccountClicked;
theme.customerEvents.publishSignupClick = publishSignupClick;

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

/* Create Vue instances function */
const createVueApp = () => {
  const app = createApp({});

  Object.entries(components).forEach(([name, module]) => {
    app.component(name, module);
  });

  return app;
};

const vueElements = document.querySelectorAll('[vue]');

if (vueElements) {
  vueElements.forEach((el) => {
    createVueApp().mount(el);
  });
}

/* properly render vue components on user insert in the theme editor */
if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.value.includes('vue')) {
      const vueElement = event.target.querySelectorAll('[vue]');
      if (vueElement) {
        vueElement.forEach((el) => {
          createVueApp().mount(el);
        });

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('modal:reregister'));
        }, 150);
      }
    }
  });
}

/** ********************************************************************************** */
/** ********************************DO NOT EDIT BELOW********************************* */
/** ********************************************************************************** */

/**
 * Custom DOMready function
 * @param {*} callback
 */
const labDOMready = (callback) => {
  if (document.readyState !== 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};

/**
 * Use this event listener to run your JS after the DOM is ready
 */
labDOMready(() => {
  document.dispatchEvent(new CustomEvent('page:loaded'));

  // Prevent Tracking in the Theme Editor
  if (!Shopify.designMode) {
    // Init engagement time tracking
    theme.customerEvents.publishEngagementTime();

    // Init scroll depth tracking
    window.addEventListener('scroll', () => {
      theme.customerEvents.publishScrollDepth();
    });
  }

  // Init Klaviyo form events
  const klaviyoForms = document.querySelectorAll('[class*="klaviyo-form-"]');
  if (klaviyoForms.length > 0) {
    theme.customerEvents.publishKlaviyoForm();
  }

  // Only monitor DOM changes when on the loyalty page
  if (document.location.pathname === theme.settings.loyalty_page_url) {
    // Monitors DOM changes from apps
    const observer = new MutationObserver((mutationsList, mutationObserver) => {
      const accountRegisterLinks = document.querySelectorAll(
        `[href="${window.theme.routes.register}"]`
      );
      if (accountRegisterLinks.length > 0) {
        accountRegisterLinks.forEach((link) => {
          link.addEventListener('click', () => {
            theme.customerEvents.publishAccountClicked();
            theme.customerEvents.publishSignupClick();
          });
        });
      }

      const accountLoginLinks = document.querySelectorAll(`[href="${window.theme.routes.login}"]`);
      if (accountLoginLinks.length > 0) {
        accountLoginLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            theme.customerEvents.publishAccountClicked();
            window.location.href = window.theme.routes.login;
          });
        });
      }

      // Disconnect the observer after finding the target
      if (accountRegisterLinks.length > 0 && accountLoginLinks.length > 0) {
        mutationObserver.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true, // Watch for changes to children
      subtree: true, // Include all nested children
    });

    setTimeout(() => {
      observer.disconnect();
      console.log('Timeout: Unable to find register links.');
    }, 10000);
  }
});
